// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/weather-contractions.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/weather-contractions/weather-contractions.js';

mount([g0]);
